import { useTranslation } from 'react-i18next'
import { useState, useEffect } from 'react'
import { languages, type LanguageCode } from '../i18n'

export default function LanguageSwitcher() {
  const { i18n, t } = useTranslation()
  const [currentLang, setCurrentLang] = useState<LanguageCode>(i18n.language as LanguageCode)

  // Sync with i18n language changes (including initial load from localStorage)
  useEffect(() => {
    const handleLanguageChanged = (lng: string) => {
      setCurrentLang(lng as LanguageCode)
    }

    // Set initial language from i18n (which loads from localStorage)
    setCurrentLang(i18n.language as LanguageCode)

    // Listen to language changes
    i18n.on('languageChanged', handleLanguageChanged)

    return () => {
      i18n.off('languageChanged', handleLanguageChanged)
    }
  }, [i18n])

  const handleLanguageChange = (langCode: LanguageCode) => {
    i18n.changeLanguage(langCode)
  }

  // Note: Document direction is now handled in i18n/index.ts on languageChanged event

  return (
    <div className="relative">
      <select
        value={currentLang}
        onChange={(e) => handleLanguageChange(e.target.value as LanguageCode)}
        aria-label={t('language.select')}
        className="bg-slate-100 text-slate-700 text-xs sm:text-sm font-medium rounded-lg px-2 sm:px-3 py-1.5 sm:py-2 cursor-pointer hover:bg-slate-200 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-0 appearance-none"
      >
        {languages.map((lang) => (
          <option key={lang.code} value={lang.code}>
            {lang.name}
          </option>
        ))}
      </select>
    </div>
  )
}
